const UnderConstruction = (props) => {
    const { options, value, disabled, readonly, onChange } = props;

    return (
        <div className="darzo-customfield-underconstruction">
            <strong>Under construction</strong>
        </div>
    );
};

export default UnderConstruction;
